import * as React from 'react';
import { Theme } from '@mui/styles';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import {Button} from '@mui/material';
import { Typography } from '@mui/material';
import {Dialog, DialogTitle, DialogContent, DialogActions} from '@mui/material';
import {Grid} from '@mui/material';
import * as request from 'superagent';
import URLManager from '~common/lib/url-manager';
import { setValueAtPath } from '~common/form/helper';
import DefinitionSection from '~common/form/definition-section';


type State = {
   open: boolean;
   error?: any;
};

interface Props extends React.HTMLProps<HTMLDivElement> {
   classes: any;
   open: boolean;
   action: any;
   handleYes: ()=>void;
   handleNo: ()=>void
   handleClose: ()=>void
   targetSection: any;
  }

  const styles = (theme:Theme):StyleRules => ({
    modalContent: {
        width: 500
    },
    actionAutoConfirmButtonClass:{
        border: 'dashed 1px #dedede'
    },
    modalTitle: {
        padding: "0px 0px 20px 0px"
    },
    gridItem: {
        paddingBottom: "0px !important;",
        paddingTop: "0px !important;"
    },
    controlContainer: {
        width: "100%",
        padding: 0
    },
    dangerButton: {
        backgroundColor: "#af0202",
        '&:hover': {
            backgroundColor: "#5D0A0A !important"
        }
    }
})

class SequenceEditorPresentSave extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
    constructor(props: Props) {
        super(props, {});
        this.state = {
            open: true
        }
      }

    
   componentDidMount() {
   
    }
    
    handleYes = (save: boolean) => {
        if (this.props.handleYes) {
            this.props.handleYes()
        }
    }

    handleNo = () => {
        if (this.props.handleNo) {
            this.props.handleNo()
        }
    }

    handleClose = (event, reason) => {
        if (reason !== 'backdropClick') {
            this.props.handleClose()
        }
    }


    render() {
        const { classes }: { classes: ClassNameMap;} = this.props;
        const {open} = this.state

        return (
            <Dialog
                className={classes.modal}
                open={open}
                onClose={this.handleClose}
            >   
                <DialogContent className={classes.modalContent}>
                    <DialogTitle className={classes.modalTitle}>
                        Save?
                    </DialogTitle>  
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Typography dangerouslySetInnerHTML={{ __html: "The section you are leaving has unsaved changes. Would you like to save?"}} variant="body1"></Typography> 
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{justifyContent: "flex-start"}}>
                    <div style={{flex:1}}></div>
                    <Button 
                        variant="contained"
                        color="inherit"
                        onClick={this.handleNo.bind(this)}>
                        {"No"}
                    </Button>
                    {<Button 
                        autoFocus={true}
                        variant="contained"
                        color="primary"
                        onClick={this.handleYes.bind(this)}>
                        {"Yes"}
                    </Button>}
                </DialogActions>
            </Dialog>
        )
    }
}

export default withStyles(styles)(SequenceEditorPresentSave);